<template>

  <div class="flex-grow">
    <div class="bg-theme-light">
      <div class="section container px-6 py-16 mx-auto">
          <div class="items-center lg:flex">
              <div class="w-full flex flex-col jusctify-center text-center">
                  <h1 class="text-5xl text-theme-blue font-semibold">{{title}}</h1>
                  <h4 class="text-gray-900 text-xl w-11/12 md:w-9/12 m-auto text-center font-normal py-6">{{subtitle}}</h4>
              </div>
          </div>
      </div>
    </div> 

    <div class="section container mx-auto py-20">
        <div class="grid grid-cols-4 gap-5 px-2">
            <div v-show="listnac.length" class="col-span-4">
              <h2 class="text-xl font-bold uppercase">{{cat1.title}}</h2>
              <h4 class="text-gray-500">{{cat1.description}}</h4>
            </div>

            <div v-for="item in listnac" :key="item.id" 
                 class="col-span-4 md:col-span-1 px-2  py-1  rounded-xl shadow hover:shadow-xl  hover:text-theme-sky cursor-pointer">
              <a class="flex items-center" :href="item.url" target="_blank">
              <img :src="`${baseUrl}${item.image}`" class="w-1/4 md:w-1/3 rounded-lg" alt="">
              <div class="ml-4 capitalize">{{item.title}}</div></a>
            </div>

            <div v-show="listpub.length" class="col-span-4 mt-20">
              <h2 class="text-xl font-bold uppercase">{{cat2.title}}</h2>
              <h4 class="text-gray-500">{{cat2.description}}</h4>
            </div>

            <div v-for="item in listpub" :key="item.id" 
                 class="col-span-4 md:col-span-1 px-2  py-1  rounded-xl shadow hover:shadow-xl  hover:text-theme-sky cursor-pointer">
              <a class="flex items-center" :href="item.url" target="_blank">
              <img :src="`${baseUrl}${item.image}`" class="w-1/4 md:w-1/3 rounded-lg" alt="">
              <div class="ml-4 capitalize">{{item.title}}</div></a>
            </div>

            <div v-show="listvir.length"  class="col-span-4 mt-20">
              <h2 class="text-xl font-bold uppercase">{{cat3.title}}</h2>
              <h4 class="text-gray-500">{{cat3.description}}</h4>
            </div>

            <div v-for="item in listvir" :key="item.id" 
                 class="col-span-4 md:col-span-1 px-2  py-1  rounded-xl shadow hover:shadow-xl  hover:text-theme-sky cursor-pointer">
              <a class="flex items-center" :href="item.url" target="_blank">
              <img :src="`${baseUrl}${item.image}`" class="w-1/4 md:w-1/3 rounded-lg" alt="">
              <div class="ml-4 capitalize">{{item.title}}</div></a>
            </div>

 
            <div v-show="listinv.length" class="col-span-4 mt-20">
              <h2 class="text-xl font-bold uppercase">{{cat4.title}}</h2>
              <h4 class="text-gray-500">{{cat4.description}}</h4>
            </div>

            <div v-for="item in listinv" :key="item.id" 
                 class="col-span-4 md:col-span-1 px-2  py-1  rounded-xl shadow hover:shadow-xl  hover:text-theme-sky cursor-pointer">
              <a class="flex items-center" :href="item.url" target="_blank">
              <img :src="`${baseUrl}${item.image}`" class="w-1/4 md:w-1/3 rounded-lg" alt="">
              <div class="ml-4 capitalize">{{item.title}}</div></a>
            </div>
          

            <div v-show="listbib.length" class="col-span-4 mt-20">
              <h2 class="text-xl font-bold uppercase">{{cat5.title}}</h2>
              <h4 class="text-gray-500">{{cat5.description}}</h4>
            </div>

            <div v-for="item in listbib" :key="item.id" 
                 class="col-span-4 md:col-span-1 px-2  py-1  rounded-xl shadow hover:shadow-xl  hover:text-theme-sky cursor-pointer">
              <a class="flex items-center" :href="item.url" target="_blank">
              <img :src="`${baseUrl}${item.image}`" class="w-1/4 md:w-1/3 rounded-lg" alt="">
              <div class="ml-4 capitalize">{{item.title}}</div></a>
            </div>


        </div>
    </div>     

  </div> 

</template>


<script>

// import Slider  from  '@/components/bibliotecas/Slider'
// import Intro   from  '@/components/bibliotecas/Intro'
// import Content from  '@/components/bibliotecas/Content'

export default {
  name: "LinksExternos",
  components: {

  },
  data(){
      return{
          title:"",
          subtitle:"",
          list: "",
          listnac: "",
          listpub: "",
          listvir: "",
          listinv: "",
          listbib: "",
          categories: "",
          cat1: "",
          cat2: "",
          cat3: "",
          cat4: "",
          cat5: "",
          baseUrl: process.env.VUE_APP_URL_CULTURAPP
      }
  },
  methods:{
    async getContent(view){

      var filter = `?view=${view}`
      var get = `${process.env.VUE_APP_URL_CULTURAPP}api/contents${filter}`
      const response = await fetch(get,{method: 'GET'})
      const contents = await response.json()

      this.title = contents.filter(obj => obj.section == 'header' && obj.element == 'title')[0].content
      this.subtitle = contents.filter(obj => obj.section == 'header' && obj.element == 'subtitle')[0].content
    },

    async getLinks(){
        var get = `${process.env.VUE_APP_URL_CULTURAPP}api/links`;
        const response = await fetch(get,{method: 'GET'})
        this.list = await response.json()

        var get = `${process.env.VUE_APP_URL_CULTURAPP}api/linkscategories`;
        const r2 = await fetch(get,{method: 'GET'})
        this.categories = await r2.json()
    },
  },
  watch:{
    list:function(){
      this.listnac = this.list.filter(obj => obj.linkcategory_id == 1) 
      this.listpub = this.list.filter(obj => obj.linkcategory_id == 2) 
      this.listvir = this.list.filter(obj => obj.linkcategory_id == 3) 
      this.listinv = this.list.filter(obj => obj.linkcategory_id == 4) 
      this.listbib = this.list.filter(obj => obj.linkcategory_id == 5) 
    },
    categories: function(){
      this.cat1 = this.categories.filter(obj => obj.id == 1)[0] 
      this.cat2 = this.categories.filter(obj => obj.id == 2)[0] 
      this.cat3 = this.categories.filter(obj => obj.id == 3)[0] 
      this.cat4 = this.categories.filter(obj => obj.id == 4)[0] 
      this.cat5 = this.categories.filter(obj => obj.id == 5)[0] 

    }

  },
  created(){
      this.getContent('links')
      this.getLinks()
  },
  mounted () {
    window.scrollTo(0, 0)
  }

};
</script>
